// @material-ui
import { makeStyles } from '@material-ui/styles';


export const iframeStyle = (theme) => ({
  root: {
    height: `calc(100% - ${theme.spacing(8)}px)`
  },

  iframe: {
    width: '100%',
    border: 'none'
  }
});

export const useStyle = makeStyles(iframeStyle);
